import { Box, Stack } from "@mui/material";
import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

interface Props {
  item: {
    name: string;
    path: string;
  };
}

const DetailMenuItem = ({ item }: Props) => {
  const { pathname } = useLocation();

  const active = useMemo(() => {
    return pathname.includes(item.path);
  }, [item.path, pathname]);

  return (
    <Box
      key={item.name}
      sx={{
        borderLeft: active
          ? "3px solid var(--Primary-Primary-500, #00B6B9)"
          : "",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
        ml={1}
        sx={{
          backdropFilter: "blur(12px)",
          alignSelf: "stretch",
        }}
      >
        <Link
          to={item.path}
          style={{
            fontSize: "1.1rem",
            fontWeight: active ? 700 : 600,
            color: active ? "#00B6B9" : "#000000",
          }}
        >
          {item.name}
        </Link>
      </Stack>
    </Box>
  );
};

export default DetailMenuItem;
